import cloneDeepWith from 'lodash/cloneDeepWith';
import { INTEGRATION_TYPES, typeTextMap } from '@model';
import { filterHtmlModuleRadios } from '@utils/htmlModuleConfig';

export const SectionRadioLabel = {
  Image: 'Image',
  PBI: 'Power BI dashboard',
  PDF: 'PDF',
  Richtext: 'Text Box',
  Other: 'Other (e.g., URL, non-PBI iFrame)',
};

const projectModuleRadios = [
  {
    value: 'powerbiModule',
    text: SectionRadioLabel.PBI,
    typeText: 'Power BI',
    // tipTitle:
    //   'Create a module on the left pane to quickly navigate to an iFramed Power BI dashboard',
  },
  {
    value: 'imageModule',
    text: SectionRadioLabel.Image,
    typeText: 'Image',
  },
  {
    value: INTEGRATION_TYPES.PDF,
    text: 'PDF',
    typeText: 'PDF',
  },
  {
    value: INTEGRATION_TYPES.HTML,
    text: 'HTML',
    typeText: 'HTML',
  },
  {
    value: 'regular',
    text: SectionRadioLabel.Other,
    typeText: 'Other',
  },
  {
    value: INTEGRATION_TYPES.WIDGET,
    // text: 'Visualization Widget (e.g., Gantt Chart, Waterfall Chart, etc.)',
    text: 'Visualization Widget (Spider Chart)',
    typeText: 'Visualization Widget',
  },
  {
    value: INTEGRATION_TYPES.TEXT_CONTAINER,
    text: SectionRadioLabel.Richtext,
    typeText: 'Text',
  },
  {
    value: INTEGRATION_TYPES.MULTI_SECTION,
    text: 'Multi-section',
    typeText: 'Multi-section',
  },
  // {
  //   value: INTEGRATION_TYPES.M365,
  //   text: INTEGRATION_TYPES.M365,
  //   typeText: INTEGRATION_TYPES.M365,
  // },
];

/**
 * config of add modal in project
 */
export const projectModuleAddModalConfig = {
  addTitle: 'Add New Module',
  addNew: 'Module Type',
  isModule: true,
  radios: filterHtmlModuleRadios(projectModuleRadios),
  typeTextMap,
  ratioNeedFullSize: true,
};
export const navigationTilesAddModalConfig = {
  addTitle: 'Add New Tile',
  addNew: 'Tile Type',
  radios: [
    {
      value: 'powerbi',
      text: SectionRadioLabel.PBI,
      //   tipTitle:
      //     'Create a tile on the left pane to quickly navigate to an iFramed PowerBI dashboard',
      typeText: 'Power BI',
    },
    {
      value: 'pdf',
      text: SectionRadioLabel.PDF,
      // tipTitle: 'Create a tile on the left pane to quickly navigate to any ',
      typeText: 'PDF',
    },
    {
      value: 'image',
      text: SectionRadioLabel.Image,
      typeText: 'Image',
    },
    {
      value: 'text',
      text: SectionRadioLabel.Other,
      typeText: 'Other',
    },
    {
      value: INTEGRATION_TYPES.TEXT_CONTAINER,
      text: SectionRadioLabel.Richtext,
      typeText: 'Text',
    },
    // {
    //   value: INTEGRATION_TYPES.M365,
    //   text: INTEGRATION_TYPES.M365,
    //   typeText: INTEGRATION_TYPES.M365,
    // },
  ],
  typeTextMap,
  ratioNeedFullSize: true,
};
export const projectHomeAddModalConfig = {
  addTitle: 'Add New Section',
  addNew: 'Section Type',
  radios: [
    ...navigationTilesAddModalConfig.radios,
    {
      value: INTEGRATION_TYPES.CHART,
      // text: 'Visualization Widget (e.g., Gantt Chart, Waterfall Chart, etc.)',
      text: 'Visualization Widget (Spider Chart)',
      typeText: 'Chart',
    },
  ],
  typeTextMap,
};

const removeM356Option = (value, key) => {
  if (key === 'radios') {
    return value.filter((i) => i.value !== INTEGRATION_TYPES.M365);
  }
};

export const projectModuleAddModalConfigOnSystemSetting = cloneDeepWith(
  projectModuleAddModalConfig,
  removeM356Option,
);
export const navigationTilesAddModalConfigOnSystemSetting = cloneDeepWith(
  navigationTilesAddModalConfig,
  removeM356Option,
);
export const projectHomeAddModalConfigOnSystemSetting = cloneDeepWith(
  projectHomeAddModalConfig,
  removeM356Option,
);
